import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-driver-event',
	templateUrl: './driver-event.component.html',
	styleUrls: ['./driver-event.component.css'],
})
export class DriverEventComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 2;
	protected parentComponent = 'driver-event';
	protected apiUrl = '/driversEvents/';
	protected apiUrlAdd = '/driversEvents/';
	protected driverSalaryConfirmed = false;
	data = {
		id: this.route.snapshot.params['id'],
		drivers: null,
		date_from: null,
		date_to: null,
		type: null,
		comments: null,
		status: 1,
	};
	drivers: Array<any> = [];
	types: Array<any> = [];
	returnDate = '';

	protected loadBefore() {
		this.api.get('/driversEventsTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/drivers/?in_calendar=1', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
	}

	protected getApiUrl(): string {
		return this.apiUrl + this.data.id;
	}
}
